import styled, { css } from 'styled-components';
import { breakpoints, h5 } from '../../styles';
const textAlignMdBreakpoint = css `
  @media (max-width: ${breakpoints.md}px) {
    text-align: left;
  }
`;
export const TitlesContainer = styled.div `
  ${textAlignMdBreakpoint}
`;
export const Title = styled.h2 `
  padding-bottom: 1rem;
  @media (max-width: ${breakpoints.md}px) {
    padding-bottom: 0.5rem;
  }
`;
export const Eyebrow = styled.p `
  ${h5}
`;
export const HorizontalLine = styled.hr `
  margin-top: 0;
`;
export const BodyCopy = styled.div `
  p {
    @media (max-width: ${breakpoints.md}px) {
      text-align: left;
    }
  }
`;
export const CTAs = styled.div `
  ${({ appearance }) => !appearance &&
    `@media (min-width: ${breakpoints.md}px) {
      h3 {
        text-align: center !important;

        span {
          position: absolute;
          left: -1.25rem;
        }
      }
    }
      `}

  ${textAlignMdBreakpoint}
`;
//# sourceMappingURL=UiFeatureSection.styles.js.map